import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {CurrentModule, ExtendedModule, Module} from '@/types/module';

interface ModulesState {
  modules: Module[];
  formModules: ExtendedModule[];
  currentModule: CurrentModule;
}

export const initialState: ModulesState = {
  modules: [],
  formModules: [],
  currentModule: {
    key: '',
    url: '',
    picture: null,
    label: {
      de: '',
      en: ''
    },
    labelLanguage: 'de'
  }
};

const modulesSlice = createSlice({
  name: 'modules',
  initialState: initialState,
  reducers: {
    setModules(state, action: PayloadAction<Module[]>) {
      state.modules = action.payload;
    },
    setFormModules(state, action: PayloadAction<ExtendedModule[]>) {
      state.formModules = action.payload;
    },

    setCurrentModule(state, action: PayloadAction<Partial<CurrentModule>>) {
      state.currentModule = {...state.currentModule, ...action.payload};
    },
    resetCurrentModule(state) {
      state.currentModule = {...initialState.currentModule};
    }
  }
});

export const {
  setModules,
  setFormModules,
  setCurrentModule,
  resetCurrentModule
} = modulesSlice.actions;
export default modulesSlice.reducer;
